import { render, staticRenderFns } from "./PmauPermissoes.vue?vue&type=template&id=bc32f7aa&scoped=true&"
import script from "./PmauPermissoes.vue?vue&type=script&lang=js&"
export * from "./PmauPermissoes.vue?vue&type=script&lang=js&"
import style0 from "./PmauPermissoes.vue?vue&type=style&index=0&id=bc32f7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc32f7aa",
  null
  
)

export default component.exports